import React from 'react';
import Style from './formPreview.module.css';
import { CountrySelectorLabel } from '../../../nacre/components/countrySelector';
import { useTranslation } from 'react-i18next';

export default function FormCountry({ field, label, value = null, id = null, onChangeForm = () => {} }) {
    const { t } = useTranslation();
    const [country, setCountry] = React.useState();

    const onChange = React.useCallback(
        v => {
            if (id) {
                onChangeForm(id, v);
                return;
            }
            setCountry(v);
        },
        [id]
    );

    return (
        <div className={Style['field']}>
            <CountrySelectorLabel placeholder={t('ticket.common.action.select')} label={label} value={id ? value : country} onChange={value => onChange(value)} />
        </div>
    );
}
